import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";

import { useTranslation } from "react-i18next";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import WorkoutLibrary from "./WorkoutLibrary";
import ExerciseLibrary from "./ExerciseLibrary";
import BlockLibrary from "./BlockLibrary";
import ModifierLibrary from "./ModifierLibrary";
import { useScreenDimensions, useDevice } from "../../_layout";
import FormLibrary from "./FormLibrary";
import LogoImage from "../../Components/LogoImage";
import { observer } from "mobx-react";

const TabBar = React.memo(({ coach, selectedTab, t, isMobile }) => {
  const scrollViewRef = useRef(null);

  const OptionButton = ({ option }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => coach.setProperty("librarySelectedTab", option)}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ alignItems: "center" }}>
          <Text
            style={[
              styles.tabText,
              {
                color: "black",
              },
            ]}
          >
            {t(option)}
          </Text>
          <View
            style={[
              styles.underline,
              {
                backgroundColor:
                  selectedTab === option
                    ? Colors.bubbleColor
                    : isHovered
                    ? "rgba(63, 123, 141, 0.65)"
                    : "transparent",
              },
            ]}
          />
        </View>
      </TouchableOpacity>
    );
  };

  const TabOptions = [
    "forms-string",
    "blocks-string",
    "workouts-string",
    "exercises-string",
    "modifiers-string",
  ];

  return (
    <>
      <View style={{}}>
        <ScrollView
          ref={scrollViewRef}
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{
            marginTop: 24,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            {TabOptions.map((option, index) => (
              <View
                style={{
                  flexDirection: "row",
                  marginRight: index < TabOptions.length - 1 ? 24 : 0,
                }}
                key={index}
              >
                <OptionButton option={option} />
                <View style={{ flex: 1 }} />
              </View>
            ))}
          </View>
        </ScrollView>
      </View>
      <View
        style={{
          maxHeight: 1,
          flex: 1,
          backgroundColor: Colors.borderColor,
        }}
      />
    </>
  );
});

const CoachLibrary = observer(({ coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const selectedTab = coach.librarySelectedTab;

  const TabOptions = [
    "forms-string",
    "blocks-string",
    "workouts-string",
    "exercises-string",
    "modifiers-string",
  ];

  const components = {
    "forms-string": FormLibrary,
    "blocks-string": BlockLibrary,
    "workouts-string": WorkoutLibrary,
    "exercises-string": ExerciseLibrary,
    "modifiers-string": ModifierLibrary,
  };

  const ComponentToShow = components[selectedTab] || null;

  useEffect(() => {
    coach.setProperty("searchTermFormLibrary", "");
    coach.setProperty("searchTermBlockLibrary", "");
    coach.setProperty("searchTermWorkoutLibrary", "");
    coach.setProperty("searchTermPred", "");
    coach.setProperty("searchTermAttr", "");
  }, []);

  return (
    <View style={styles.container}>
      <View>
        <View
          style={[GlobalStyles.HStack, { width: "100%", alignItems: "center" }]}
        >
          <Text
            style={[
              Fonts.bold24,
              { marginRight: screenSize === "small" ? 8 : 12 },
            ]}
          >
            {t("library-string")}
          </Text>
          <SyncStatusIndicator
            syncStatusManager={coach.syncStatusManager}
            onPress={() => coach.startOrResetBatchTimer()}
          />
          <View style={{ flex: 1 }} />

          <LogoImage coach={coach} />
        </View>

        {coach && (
          <TabBar
            coach={coach}
            selectedTab={selectedTab}
            t={t}
            isMobile={isMobile}
          />
        )}
        {ComponentToShow && <ComponentToShow coach={coach} />}
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  tabText: {
    fontSize: 16,
    fontWeight: "500",
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 5,
  },
});

export default CoachLibrary;
